import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabsListProvider } from '#pplx/frontend/aether/components/Tabs/internal/TabsStructureContext.js';
import { TabsContext, useTabsContext } from '#pplx/frontend/aether/components/Tabs/TabsContext.js';
import { TabsIndicator } from '#pplx/frontend/aether/components/Tabs/TabsIndicator.js';
import { useRadixProps } from '#pplx/frontend/aether/internal/useRadixProps.js';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cva } from 'class-variance-authority';
import classNames from 'classnames';
import { useMemo, useRef } from 'react';
const getTabsListClasses = cva('flex flex-row flex-nowrap', {
    variants: {
        showBottomBorder: {
            false: '',
            true: 'border-b',
        },
        fullWidth: {
            false: '',
            true: 'gap-0',
        },
        size: {
            default: 'h-[54px]',
            compact: 'h-11',
        },
        variant: {
            underline: '',
            button: 'w-max items-center gap-2 h-auto',
            'button-inverse': 'w-max items-center gap-2 h-auto',
        },
    },
    compoundVariants: [
        {
            fullWidth: false,
            size: 'default',
            variant: 'underline',
            class: 'gap-5',
        },
        {
            fullWidth: false,
            size: 'compact',
            variant: 'underline',
            class: 'gap-4',
        },
    ],
    defaultVariants: {
        showBottomBorder: false,
        fullWidth: false,
        size: 'default',
        variant: 'underline',
    },
});
export function TabsList({ children, 'aria-label': ariaLabel, showBottomBorder = false, fullWidth = false, size = 'default', variant = 'underline', ...props }) {
    const __radixProps = useRadixProps(props);
    const parentContext = useTabsContext();
    const listRef = useRef(null);
    // Wrap parent context to add fullWidth, size, and variant
    const contextValue = useMemo(() => ({
        ...parentContext,
        fullWidth,
        size,
        variant,
    }), [parentContext, fullWidth, size, variant]);
    return (_jsx(TabsContext.Provider, { value: contextValue, children: _jsx(TabsPrimitive.List, { ref: listRef, "aria-label": ariaLabel, className: classNames(getTabsListClasses({
                showBottomBorder: variant === 'underline' ? showBottomBorder : false,
                fullWidth,
                size,
                variant,
            }), 'relative'), ...__radixProps, children: _jsxs(TabsListProvider, { children: [children, _jsx(TabsIndicator, { listRef: listRef })] }) }) }));
}
//# sourceMappingURL=TabsList.js.map